import { ReactNode } from 'react';

export interface EyebrowProps {
  children: ReactNode;
  /** Adds a 24px red rule trailing the label. */
  withRule?: boolean;
  /** Color tone — 'red' uses --vm-red, 'stone' (default) uses --vm-stone. */
  tone?: 'red' | 'stone' | 'warm';
}

/** Uppercase 11px / 0.3em-tracked label. Spec § 5 typography table. */
export function Eyebrow({ children, withRule, tone = 'stone' }: EyebrowProps) {
  const color =
    tone === 'red' ? 'var(--vm-red)' :
    tone === 'warm' ? 'var(--vm-warm-white)' :
    'var(--vm-stone)';

  return (
    <span
      data-tone={tone}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 'var(--vm-s-1)',
        fontFamily: 'var(--vm-font-heading)',
        fontSize: 11,
        lineHeight: 1,
        letterSpacing: '0.3em',
        textTransform: 'uppercase',
        color,
      }}
    >
      {children}
      {withRule && (
        <span
          data-vm-rule
          aria-hidden="true"
          style={{ width: 24, height: 1, background: 'var(--vm-red)' }}
        />
      )}
    </span>
  );
}
